import axios from "axios";

// export const BASE_URL = "http://localhost:8000/api/v1";
// export const IMG_URL = "http://localhost:8000/api/v1/get-images";
// export const BASE_URL = "http://192.168.1.14:8000/api/v1";
// export const IMG_URL = "http://192.168.1.14:8000/api/v1/get-images";
export const BASE_URL = "https://api.sshealthconnect.com/api/v1";
export const IMG_URL = "https://api.sshealthconnect.com/api/v1/get-images";
const api = axios.create({ baseURL: BASE_URL });
const addressApi = axios.create({ baseURL: BASE_URL });
const getAccessToken = () => {
  const token = localStorage.getItem("token")
  return token;
};
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.method === "get" || config.method === "delete") {
      config.params = { ...config.params };
    } else {
      config.data = { ...config.data };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

addressApi.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const loginApi = async (userData) => {
  try {
    const response = await api.post(`/admin/login`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Login failed";
  }
};


export const createBlogCategoryApi = async (userData) => {
  try {
    const response = await api.post(`/blog-category/create-category`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const createProductCategoryApi = async (userData) => {
  try {
    const response = await api.post(`/product-category/create-category`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const createGalleryCategoryApi = async (userData) => {
  try {
    const response = await api.post(`/gallery-category/create-category`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const updateBlogCategoryApi = async (userData) => {
  try {
    console.log("USER DATA ::", userData);
    let { id, } = userData
    const response = await api.put(`/blog-category/update-category/${id}`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const updateProductCategoryApi = async (userData) => {
  try {
    console.log("USER DATA ::", userData);
    let { id, } = userData
    const response = await api.put(`/product-category/update-category/${id}`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const updateGalleryCategoryApi = async (userData) => {
  try {
    console.log("USER DATA ::", userData);
    let { id, } = userData
    const response = await api.post(`/gallery-category/update-category`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};




export const getBlogCategoriesApi = async (userData) => {
  try {
    const response = await api.get(`/blog-category/get-categories`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const getProductCategoriesApi = async (userData) => {
  try {
    const response = await api.get(`/product-category/get-categories`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
}

export const getGalleryCategoriesApi = async (userData) => {
  try {
    const response = await api.get(`/gallery-category/get-all-categories`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



export const deleteBlogcategoryApi = async (userData) => {
  try {
    console.log("USER DATA ::", userData);

    const response = await api.delete(`/blog-category/delete-category/${userData?.id}`,);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const deleteProductcategoryApi = async (userData) => {
  try {
    console.log("USER DATA ::", userData);

    const response = await api.delete(`/product-category/delete-category/${userData?.id}`,);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const deleteGallerycategoryApi = async (userData) => {
  try {
    console.log("USER DATA ::", userData);

    const response = await api.delete(`/gallery-category/delete-category/${userData?.id}`,);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


//Tags



export const createBlogTagsApi = async (userData) => {
  try {
    const response = await api.post(`/blog-tags/create-tag`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const updateBlogTagsApi = async (userData) => {
  try {
    console.log("UPDATE BLOG TAG ::", userData);

    const response = await api.put(`/blog-tags/update-tag/${userData?.id}`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};




export const getBlogTagsApi = async (userData) => {
  try {
    const response = await api.get(`/blog-tags/get-all-tags`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



export const deleteBlogTagsApi = async (userData) => {
  try {
    console.log("DELETE BLOG TAG ::", userData);

    const response = await api.delete(`/blog-tags/delete-tag/${userData?.id}`);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



//Get All Blogs



export const getAllBlogsApi = async (userData) => {
  try {
    const response = await api.post(`/blogs/get-all-blogs-admin`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


//Create Blog



export const createBlogApi = async (formData) => {
  try {
    const token = getAccessToken();

    const response = await axios.post(`${BASE_URL}/blogs/create-blog`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    // throw error.response?.data?.message || "failed!";

    error.customMessage = error.response?.data?.message || "Failed";
    throw error;
  }
};

export const updateBlogApi = async (formData, id) => {
  try {
    const token = getAccessToken();
    console.log("UPDATE BLOG REQ ::", id);

    const response = await axios.put(`${BASE_URL}/blogs/update-blog/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    // throw error.response?.data?.message || "failed!";

    error.customMessage = error.response?.data?.message || "Failed";
    throw error;
  }
};

//Delete Blogs

export const deleteBlogsApi = async (userData) => {
  try {
    console.log("DELETE BLOG ::", userData);

    const response = await api.delete(`/blogs/delete-blog/${userData?.id}`);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


//Slider Management 



export const getSliderImagesApi = async () => {
  try {
    const response = await api.get(`/slider/get-images-url`);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


export const addSliderImageApi = async (userData) => {
  try {
    const response = await api.post(`/add-slider-image/admin`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    error.customMessage = error.response?.data?.message || "Failed";
    throw error;
  }
};


export const deleteSliderImageApi = async (userData) => {
  try {
    console.log("DELETE SLIDER ::", userData);

    const response = await api.delete(`/slider/delete-image/${userData.id}`);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



export const createCaseStudyApi = async (userData) => {
  try {
    const token = getAccessToken();

    const response = await axios.post(`${BASE_URL}/create-and-update-case-study/admin`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    error.customMessage = error.response?.data?.message || "Failed";
    throw error;
  }
};


//Get All Case Studies

export const getCaseStudies = async () => {
  try {
    const response = await api.get(`/get-case-study/admin`);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



export const deleteCaseStudies = async (userData) => {
  try {
    const response = await api.post(`/delete-case-study/admin`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


export const getDashboardDetailsApi = async (userData) => {
  try {
    const response = await api.get(`/dashboard/get-dashboard-details`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

//Get Contact Inquiry API


// /get-contact-inquiry

export const getContactInquiryAPi = async (userData) => {
  try {
    const response = await api.get(`/contact-us`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const getProductInquiryApi = async (userData) => {
  try {
    const response = await api.get(`/products/get-product-inquiry`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const getBookedInquiry = async (userData) => {
  try {
    const response = await api.get(`/appointment/get-appointment`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const getTestimonialsApi = async (userData) => {
  try {
    let response = await api.get(`/testimonials/get-testimonials`)
    return response.data
  } catch (error) {
    console.log(error);
    throw error.reponse.data.message || "Check Network Connection"

  }
}

export const deleteTestimonialApi = async (id) => {
  try {
    let response = await api.delete(`/testimonials/delete-testimonial/${id}`)
    return response.data
  } catch (error) {
    console.log(error);
    throw error.reponse.data.message || "Check Network Connection"

  }
}


export const changePasswordApi = async (userData) => {
  try {
    const response = await api.put(`/admin/change-password`, userData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

//Edit Product Integration

export const editProductApi = async (productData, productId) => {
  try {
    const response = await api.put(`products/update-product/${productId}`, productData);
    return response.data;
  } catch (error) {
    console.log(error);

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export { api, addressApi };
